module.exports = __webpack_public_path__ + "img/olympic-background-mobile.112d8778.png";